import React, { useState, useEffect, useRef } from "react";
import cn from "classnames";
import styles from "./Index.module.sass";
import Card from "../../components/Card";
import Form from "../../components/Form";
import Panel from "./Panel";
import OrderLineItems from "./OrderLineItems/index";
import { message } from "antd";
import CameraImage from "../../assets/images/camera2.png";
import {
  FETCH_RTO_ORDER_DETAILS,
  GET_CAMERAS,
  GET_ALL_CAMERA_SETTINGS,
  GENERATE_ORDER_MEDIA_PRESIGNEDURL,
  UPLOAD_ORDER_MEDIA_METADATA,
  DELETE_ALL_ORDER_MEDIA,
  DELETE_SINGELORDER_MEDIA,
  PACK_ORDERS,
  UPDATE_INVENTORY,
  GET_TAG_BY_ACTION_BARCODE,
  UPDATE_WAREHOUSE_LOCATION,
  GET_DEFAULT_LOCATION,
  GET_VARIANT_LOCATION,
} from "../../API/Scanner";
import { GET_EMPLOYEE } from "../../API/Employee";
import Product from "./Product";
import Swal from "sweetalert2";
import Record from "../../assets/images/record.png";
import CustomToast from "../../components/CustomToast";
import Loader from "../../components/Loader";
import Image from "../../components/Image";
import errorSound from "../../assets/Sounds/error.wav";
import captureSound from "../../assets/Sounds/capture-beep.mp3";
import successSound from "../../assets/Sounds/Success.wav";
import VideoSound from "../../assets/Sounds/video-beep.mp3";
import CustomAlert from "../../components/CustomAlert";
import { useLocation, useNavigate } from "react-router";
import Dropdown from "../../components/Dropdown";
import Icon from "../../components/Icon";
import { GET_LOCATIONS } from "../../API/Inventory";

const RTOrderIndex = () => {
  const showToast = CustomToast();
  const [searchInput, setSearchInput] = useState("");
  const [currentOrder, setCurrentOrder] = useState(null);
  const [cameras, setCameras] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [capturedPhotos, setCapturedPhotos] = useState([]);
  const [recordedVideos, setRecordedVideos] = useState([]);
  const [activeRecordings, setActiveRecordings] = useState(new Set());
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [scannedBarcode, setScannedBarcode] = useState("");
  const [newcapturedPhotos, setNewCapturedPhotos] = useState([]);
  const [activeBarcode, setActiveBarcode] = useState(null);
  const [canSearchNewOrder, setCanSearchNewOrder] = useState(true);
  const [employee, setEmployee] = useState(null);
  const videoRefs = useRef([]);
  const mediaRecorder = useRef([]);
  const chunks = useRef({});
  const [cameraStreams, setCameraStreams] = useState({});
  const [mediaUploaded, setMediaUploaded] = useState(false);
  const { showAlert } = CustomAlert();
  const errorAudio = useRef(new Audio(errorSound));
  const captureAudio = useRef(new Audio(captureSound));
  const VideoAudio = useRef(new Audio(VideoSound));
  const successAudio = useRef(new Audio(successSound));
  const [recordingStartTime, setRecordingStartTime] = useState(null);
  const recordingTimerRef = useRef(null);
  const alertTimerRef = useRef(null);
  const [isRecording, setIsRecording] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [tagId, setTagId] = useState(null);
  const [locations, setLocations] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState(
    "Select the location"
  );
  const [isLocationSelected, setIsLocationSelected] = useState(false);

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (isRecording) {
        event.preventDefault();
        return (event.returnValue =
          "Recording in Progress. Are you sure you want to go back? Your recording will be lost.");
      }
    };
    const handlePopState = (event) => {
      if (isRecording) {
        const userConfirmed = window.confirm(
          "Recording in Progress. Are you sure you want to go back? Your recording will be lost."
        );
        if (!userConfirmed) {
          window.history.pushState(null, "", location.pathname);
        }
      }
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    window.addEventListener("popstate", handlePopState);
    const unlisten = () => {
      const originalPushState = window.history.pushState;
      window.history.pushState = function (state, title, url) {
        if (isRecording) {
          const userConfirmed = window.confirm(
            "Recording in Progress. Are you sure you want to go back? Your recording will be lost."
          );
          if (!userConfirmed) {
            return;
          }
        }
        originalPushState.apply(this, arguments);
      };
      return () => {
        window.history.pushState = originalPushState;
      };
    };
    const cleanUp = unlisten();
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      window.removeEventListener("popstate", handlePopState);
      cleanUp();
    };
  }, [isRecording, location.pathname, navigate]);
  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        const data = await GET_EMPLOYEE();
        setEmployee(data);
      } catch (error) {
        console.error("Failed to fetch employees:", error);
      }
    };

    fetchEmployees();
  }, []);

  useEffect(() => {
    const fetchEmployeeAndInitializeCameras = async () => {
      try {
        const employeeData = await GET_EMPLOYEE();
        setEmployee(employeeData);

        const fetchCamerasAndInitialize = async () => {
          try {
            let storedCameras = JSON.parse(
              localStorage.getItem("Camera") || "[]"
            );
            if (storedCameras.length === 0) {
              const camerasData = await GET_CAMERAS();
              storedCameras = camerasData;
              localStorage.setItem("Camera", JSON.stringify(camerasData));
            }
            setCameras(storedCameras);
            initializeCameras(storedCameras);
          } catch (error) {
            console.error("Error fetching or initializing cameras:", error);
            showToast("Failed to load camera information", "error");
          }
        };

        await fetchCamerasAndInitialize();
      } catch (error) {
        console.error("Failed to fetch employee data:", error);
        showToast("Failed to load employee data", "error");
      }
    };

    fetchEmployeeAndInitializeCameras();

    return () => {
      Object.values(cameraStreams).forEach((stream) => {
        stream.getTracks().forEach((track) => track.stop());
      });
    };
  }, []);

  const initializeCameras = async (camerasToInitialize) => {
    try {
      const streams = {};
      for (const camera of camerasToInitialize) {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: { deviceId: { exact: camera.deviceId } },
          width: { ideal: 1920 },
          height: { ideal: 1080 },
          frameRate: { ideal: 30 },
          aspectRatio: { ideal: 16 / 9 },
        });
        const videoTrack = stream.getVideoTracks()[0];
        await videoTrack.applyConstraints({
          width: { ideal: 1920 },
          height: { ideal: 1080 },
          frameRate: { ideal: 30 },
        });
        streams[camera.deviceId] = stream;
      }
      setCameraStreams(streams);
    } catch (error) {
      console.error("Error initializing camera streams:", error);
      showToast("Failed to initialize camera streams", "error");
    }
  };

  useEffect(() => {
    Object.entries(cameraStreams).forEach(([deviceId, stream]) => {
      const index = cameras.findIndex((camera) => camera.deviceId === deviceId);
      if (index !== -1 && videoRefs.current[index]) {
        videoRefs.current[index].srcObject = stream;
        videoRefs.current[index]
          .play()
          .catch((e) => console.error("Error playing video:", e));
      }
    });
    return () => {
      Object.values(cameraStreams).forEach((stream) => {
        stream.getTracks().forEach((track) => track.stop());
      });
    };
  }, [cameraStreams, cameras]);

  useEffect(() => {
    const fetchLocations = async () => {
      try {
        const locationsData = await GET_LOCATIONS();
        setLocations(locationsData);
        setIsLocationSelected(true);
        const defaultLocation = await GET_DEFAULT_LOCATION();
        if (defaultLocation) {
          const defaultLocationObj = locationsData.find(
            loc => loc.location_id === defaultLocation.location_id
          );
          if (defaultLocationObj) {
            setSelectedLocation(defaultLocationObj.name);
            showToast(`Location set to ${defaultLocationObj.name}`, "success");
            return;
          }
        }
        if (locationsData.length === 1) {
          const singleLocation = locationsData[0];
          try {
            await UPDATE_WAREHOUSE_LOCATION(singleLocation.location_id);
            setSelectedLocation(singleLocation.name);
            showToast(`Location set to ${singleLocation.name}`, "success");
          } catch (error) {
            console.error("Error setting default location:", error);
            showToast("Failed to set default location", "error");
          }
        }
      } catch (error) {
        console.error("Error initializing locations:", error);
        showToast("Error loading locations", "error");
      } finally {
        setLoading(false);
      }
    };
    fetchLocations();
  }, []);
  
  const handleLocationChange = async (locationName) => {
    if (locationName === "Select a location") {
      setSelectedLocation("Select a location");
    } else {
      const location = locations.find((loc) => loc.name === locationName);
      if (location) {
        try {
          await UPDATE_WAREHOUSE_LOCATION(location.location_id);          
          setSelectedLocation(location.name);          
          showToast(`Location set to ${location.name}`, "success");
        } catch (error) {
          console.error("Error updating default location:", error);
          showToast("Failed to set default location", "error");
        }
      }
    }
  };
  const handleSearch = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    if (!isLocationSelected) {
      showAlert(
        "Location not selected",
        "Please select a location before scanning an order.",
        "warning",
        "OK",
        null,
        0,
        false,
        false,
        false
      );
      setLoading(false);
      return;
    }
    try {
      if (canSearchNewOrder) {
        const response = await FETCH_RTO_ORDER_DETAILS(searchInput);
        if (response.status === 200) {
          const orderData = response.data.data;
          setCurrentOrder(orderData);
          setSelectedProducts([]);
          setCanSearchNewOrder(false);
          showToast("Order fetched successfully", "success");
          successAudio.current.play();
        } 
        else {
          showToast("An error occurred", "error");
          errorAudio.current.play();
        }
      } else {
        if (/^BAR_\d{3}$/.test(searchInput)) {
          await handleCameraMode(searchInput);
        } else if (/^TAG_/.test(searchInput)) {
          try {
            const response = await GET_TAG_BY_ACTION_BARCODE(searchInput);
            if (response.status === 200) {
              const tagData = response.data.data;
              setTagId(tagData.id);
              showToast(`Tag found: ${tagData.tag_name}`, "success");
              successAudio.current.play();
            } else {
              showToast("Tag not found", "error");
              errorAudio.current.play();
            }
          } catch (error) {
            console.error("Error fetching tag:", error);
            showToast("Error fetching tag", "error");
            errorAudio.current.play();
          }
        } else {
          handleSKUScan(searchInput);
        }
      }
    } catch (error) {
      console.error("Error in handleSearch:", error);
      showToast(error.response.data.err, "error");
      errorAudio.current.play();
    } finally {
      setLoading(false);
      setSearchInput("");
    }
  };

  const handleSKUScan = (sku) => {
    const matchingSku = currentOrder.LineItems.find(
      (item) => item.sku === sku || item.barcode === sku
    );
    if (matchingSku) {
      setScannedBarcode(sku);
      showToast(`Scanned SKU: ${matchingSku.name}`, "success");
      successAudio.current.play();
      setTimeout(() => {
        setScannedBarcode("");
      }, 100);
    } else {
      showToast("SKU is not matching", "error");
      errorAudio.current.play();
    }
  };
   const handleCameraMode = async (barcode) => {
    try {
      const cameraResponse = await GET_ALL_CAMERA_SETTINGS();
      if (cameraResponse.status === 200) {
        const camerasData = cameraResponse.data.data;
        let foundCameras =
          camerasData.find((setting) => setting.barcode_value === barcode)
            ?.cameras || [];

        if (foundCameras.length > 0) {
          const camerasToStart = [];
          const camerasToCapture = [];
          const isStoppingRecording = activeBarcode === barcode;

          for (let backendCamera of foundCameras) {
            const localCamera = cameras.find((c) => c.id === backendCamera.id);
            if (!localCamera) continue;
            if (backendCamera.mode === "PHOTO") {
              camerasToCapture.push(localCamera.deviceId);
            }
            else if (
              backendCamera.mode === "VIDEO" ||
              backendCamera.mode === "BOTH"
            ) {
              if (activeBarcode && barcode !== activeBarcode) {
                showToast(
                  "Cannot start new recording while another is in progress",
                  "error"
                );
                errorAudio.current.play();
                return;
              }
              camerasToStart.push(localCamera.deviceId);
            }
            if (backendCamera.mode === "BOTH" && !isStoppingRecording) {
              camerasToCapture.push(localCamera.deviceId);
            }
          }
          if (camerasToCapture.length > 0 && !isStoppingRecording) {
            capturePhoto(camerasToCapture);
          }
          if (camerasToStart.length > 0) {
            if (isStoppingRecording) {
              await stopAllRecordings();
              setActiveBarcode(null);
              showToast(`Stopped recording for barcode: ${barcode}`, "success");
              successAudio.current.play();
            } else {
              startRecording(camerasToStart);
              setActiveBarcode(barcode);
              message.success(`Camera mode activated for barcode: ${barcode}`);
            }
          }
        } else {
          showToast(`No cameras found for barcode: ${barcode}`, "error");
          errorAudio.current.play();
        }
      } else {
        setError(
          cameraResponse.data.message || "Error fetching camera settings"
        );
        errorAudio.current.play();
      }
    } catch (err) {
      console.error("Error in handleCameraMode:", err);
      setError("Network error fetching camera settings");
      errorAudio.current.play();
    }
  };
  const stopAllRecordings = async () => {
    const activeDevices = Array.from(activeRecordings);
    if (activeDevices.length > 0) {
      await stopRecording(activeDevices);
    }
  };

  //This is not being used right now
  const addWatermarkToVideo = async (videoBlob) => {
    return new Promise((resolve) => {
      const video = document.createElement("video");
      video.src = URL.createObjectURL(videoBlob);
      video.crossOrigin = "anonymous";
      video.muted = true;
      video.play();

      Swal.fire({
        title: "Processing Video...",
        html:
          '<div style="width: 100%; background: #e0e0e0; border-radius: 8px; margin-top: 10px;">' +
          '<div id="progress-bar" style="height: 20px; width: 0%; background: #76c7c0; border-radius: 8px;"></div>' +
          "</div>",
        toast: true,
        position: "top-right",
        showConfirmButton: false,
        allowOutsideClick: false,
      });

      video.onloadedmetadata = () => {
        const canvas = document.createElement("canvas");
        canvas.width = video.videoWidth || 1920;
        canvas.height = video.videoHeight || 1080;
        const ctx = canvas.getContext("2d");

        const stream = canvas.captureStream(30); // 30 FPS
        const outputRecorder = new MediaRecorder(stream, { mimeType: "video/webm" });
        const outputChunks = [];

        outputRecorder.ondataavailable = (event) => {
          if (event.data.size > 0) {
            outputChunks.push(event.data);
          }
        };

        outputRecorder.onstop = () => {
          const watermarkedBlob = new Blob(outputChunks, { type: "video/webm" });
          Swal.close(); // Close the Swal progress UI
          resolve(watermarkedBlob);
        };

        outputRecorder.start();

        const startTime = Date.now();
        const createdAt = new Date();
        const totalDuration = video.duration || 10; // Fallback to 10s if metadata is missing

        const formatTimestamp = (date) => {
          const hours = date.getHours() % 12 || 12;
          const minutes = date.getMinutes().toString().padStart(2, "0");
          const ampm = date.getHours() >= 12 ? "PM" : "AM";

          return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()} ${hours}:${minutes} ${ampm}`;
        };

        let progress = 0;

        const drawFrame = () => {
          if (video.ended || video.paused) {
            outputRecorder.stop();
            return;
          }

          ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

          ctx.font = "12px verdana";
          ctx.shadowColor = "#000";
          ctx.textAlign = "right";
          ctx.lineWidth = 2;//This line width is for strokeText 

          const padding = 20;
          const lineHeight = 30;
          const startY = canvas.height - padding;


          ctx.strokeText(`Created at: ${formatTimestamp(createdAt)}`, canvas.width - padding, startY - lineHeight * 2)
          ctx.strokeText(`By: ${employee.full_name}`, canvas.width - padding, startY - lineHeight)
          ctx.lineWidth = 0; //This line width is for text

          ctx.fillStyle = "#FFFFFF";
          ctx.fillText(`Created at: ${formatTimestamp(createdAt)}`, canvas.width - padding, startY - lineHeight * 2);
          ctx.fillText(`By: ${employee.full_name}`, canvas.width - padding, startY - lineHeight);

          const elapsedTime = Math.floor((Date.now() - startTime) / 1000);
          const formattedTimer = new Date(elapsedTime * 1000).toISOString().substr(11, 8);

          ctx.lineWidth = 2;//This line width is for strok

          ctx.strokeText(`Timer: ${formattedTimer}`, canvas.width - padding, startY)
          ctx.lineWidth = 0; //This line width is for text
          ctx.fillText(`Timer: ${formattedTimer}`, canvas.width - padding, startY);

          progress = Math.min((elapsedTime / totalDuration) * 100, 100);
          document.getElementById("progress-bar").style.width = `${progress}%`;

          requestAnimationFrame(drawFrame);
        };

        drawFrame();
      };
    });
  }
  const capturePhoto = async (cameraIds = []) => {
    const capturePromises = cameras.map(async (camera, index) => {
      if (
        videoRefs.current[index] &&
        (cameraIds.length === 0 || cameraIds.includes(camera.deviceId))
      ) {
        const video = videoRefs.current[index];

        try {
          if ("ImageCapture" in window) {
            const videoTrack = video.srcObject.getVideoTracks()[0];
            const imageCapture = new ImageCapture(videoTrack);
            const bitmap = await imageCapture.grabFrame();
            const canvas = document.createElement("canvas");
            canvas.width = 1920;
            canvas.height = 1080;

            const ctx = canvas.getContext("2d");
            ctx.drawImage(bitmap, 0, 0, canvas.width, canvas.height);
            ctx.font = "bold 24px Arial"; 
            ctx.fillStyle = "#FFFFFF";
            ctx.textAlign = "left";
            ctx.fillText(` By : ${employee.full_name}`, 20, canvas.height - 20);

            const currentDate = new Date();
            const currentTimestamp = `${currentDate.getDate()}-${
              currentDate.getMonth() + 1
            }-${currentDate.getFullYear()} ${currentDate.getHours()}:${currentDate.getMinutes()} ${
              currentDate.getHours() >= 12 ? "PM" : "AM"
            }`;

            ctx.textAlign = "right";
            ctx.fillText(
              `Time : ${currentTimestamp}`,
              canvas.width - 20,
              canvas.height - 20
            );
            return new Promise((resolve) => {
              canvas.toBlob(
                (blob) => {
                  if (blob) {
                    const newPhoto = {
                      cameraId: camera.deviceId,
                      imageBlob: blob,
                      imageUrl: URL.createObjectURL(blob),
                    };
                    resolve(newPhoto);
                  }
                },
                "image/png",
                1.0
              ); 
            });
          } else {
            // Fallback to canvas API if ImageCapture is not available
            const canvas = document.createElement("canvas");
            canvas.width = 1920;
            canvas.height = 1080;

            const ctx = canvas.getContext("2d");
            ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
            ctx.font = "bold 24px Arial";
            ctx.fillStyle = "#FFFFFF";
            ctx.textAlign = "left";
            ctx.fillText(` By : ${employee.full_name}`, 20, canvas.height - 20);

            const currentDate = new Date();
            const currentTimestamp = `${currentDate.getDate()}-${
              currentDate.getMonth() + 1
            }-${currentDate.getFullYear()} ${currentDate.getHours()}:${currentDate.getMinutes()} ${
              currentDate.getHours() >= 12 ? "PM" : "AM"
            }`;

            ctx.textAlign = "right";
            ctx.fillText(
              `Time : ${currentTimestamp}`,
              canvas.width - 20,
              canvas.height - 20
            );

            return new Promise((resolve) => {
              canvas.toBlob(
                (blob) => {
                  if (blob) {
                    const newPhoto = {
                      cameraId: camera.deviceId,
                      imageBlob: blob,
                      imageUrl: URL.createObjectURL(blob),
                    };
                    resolve(newPhoto);
                  }
                },
                "image/png",
                1.0
              );
            });
          }
        } catch (error) {
          console.error(
            `Error capturing photo for camera ${camera.name}:`,
            error
          );
          return null;
        }
      }
      return null;
    });

    const capturedPhotos = await Promise.all(capturePromises);
    const validPhotos = capturedPhotos.filter((photo) => photo !== null);

    if (validPhotos.length > 0) {
      setCapturedPhotos((prev) => [...prev, ...validPhotos]);
      captureAudio.current.play();
      const mediaData = validPhotos.map((photo) => ({
        cameraId: photo.cameraId,
        type: "image",
        blob: photo.imageBlob,
        fileName: `ppg`,
      }));

      await uploadMedia(mediaData);
    }
  };
  const startRecording = (cameraIds = []) => {
    const kbps = 1024;
    const Mbps = kbps * kbps;
    cameras.forEach((camera, index) => {
      if (
        videoRefs.current[index] &&
        (cameraIds.length === 0 || cameraIds.includes(camera.deviceId))
      ) {
        const stream = videoRefs.current[index].srcObject;
        if (stream && stream.active) {
          if (!mediaRecorder.current[index]) {
            // Configure high-quality video recording
            const options = {
              mimeType: 'video/mp4; codecs="avc1.42E01E"',
              bitsPerSecond: 8 * Mbps,
            };

            mediaRecorder.current[index] = new MediaRecorder(stream, options);
            chunks.current[camera.deviceId] = [];

            mediaRecorder.current[index].ondataavailable = (e) => {
              if (e.data.size > 0) {
                chunks.current[camera.deviceId].push(e.data);
              }
            };
            mediaRecorder.current[index].start(100);

            setActiveRecordings((prev) => new Set(prev).add(camera.deviceId));
            setIsRecording(true);
          }
        }
      }
    });
    setRecordingStartTime(Date.now());
    startRecordingTimer();
    VideoAudio.current.play();
  };
  const stopRecording = async (cameraIds = []) => {
    const stoppingPromises = [];

    cameras.forEach((camera, index) => {
      if (
        videoRefs.current[index] &&
        (cameraIds.length === 0 || cameraIds.includes(camera.deviceId))
      ) {
        if (
          mediaRecorder.current[index] &&
          mediaRecorder.current[index].state === "recording"
        ) {
          mediaRecorder.current[index].stop();

          stoppingPromises.push(
            new Promise((resolve) => {
              mediaRecorder.current[index].onstop = async () => {
                const blob = new Blob(chunks.current[camera.deviceId], {
                  type: "video/webm",
                });

                //TODO: need to thing of a diffferent way to do this
                //const watermarkedBlob = await addWatermarkToVideo(blob);
                resolve({ cameraId: camera.deviceId, videoBlob: blob});
              };
            })
          );

          mediaRecorder.current[index] = null;
          setActiveRecordings((prev) => {
            const newSet = new Set(prev);
            newSet.delete(camera.deviceId);
            return newSet;
          });
        }
      }
    });

    const newRecordedVideos = await Promise.all(stoppingPromises);
    setRecordedVideos((prevVideos) => [...prevVideos, ...newRecordedVideos]);
    setActiveRecordings((prev) => {
      if (prev.size === 0) {
        setIsRecording(false);
        clearRecordingTimer();
      }
      return prev;
    });

    const mediaData = newRecordedVideos.map((video) => ({
      cameraId: video.cameraId,
      type: "video",
      blob: video.videoBlob,
      fileName: `ppg`,
    }));

    if (mediaData.length > 0) {
      await uploadMedia(mediaData);
    }
  };
  const startRecordingTimer = () => {
    recordingTimerRef.current = setTimeout(() => {
      showRecordingAlert();
    }, 10 * 60 * 1000);
  };

  const clearRecordingTimer = () => {
    if (recordingTimerRef.current) {
      clearTimeout(recordingTimerRef.current);
    }
    if (alertTimerRef.current) {
      clearTimeout(alertTimerRef.current);
    }
    setRecordingStartTime(null);
  };
  const showRecordingAlert = () => {
    showAlert(
      "Recording Time Limit Reached",
      "You’ve been recording for over 10 minutes. To avoid unnecessary recording, the session will auto-stop in 10 seconds unless you choose to continue",
      "warning",
      "Continue Recording",
      "Stop Recording",
      10000,
      true,
      false,
      true
    ).then((result) => {
      if (result.dismiss === Swal.DismissReason.timer || result.isDismissed) {
        stopAllRecordings();
      } else if (result.isConfirmed) {
        startRecordingTimer();
      }
    });
  };

  useEffect(() => {
    return () => {
      clearRecordingTimer();
    };
  }, []);
  const uploadMedia = async (mediaData) => {
    try {
      setLoading(true);
      const response = await GENERATE_ORDER_MEDIA_PRESIGNEDURL(mediaData);
      const urls = response.data;

      const uploadPromises = mediaData.map(async (media, index) => {
        const { signedUrl, key } = urls[index];
        try {
          setLoading(true);
          await fetch(signedUrl, {
            method: "PUT",
            headers: {
              "Content-Type": media.blob.type,
            },
            body: media.blob,
          });

          const mediaMetadata = {
            order_id: currentOrder.id,
            type: "return_order_media",
            media: {
              type: media.type,
              url: urls[index].fileUrl,
              key: key
            },
          };

          await UPLOAD_ORDER_MEDIA_METADATA(mediaMetadata);
          setLoading(true);
          return mediaMetadata;
        } catch (error) {
          console.error(
            `Error uploading media ${index} to presigned URL:`,
            error
          );
          throw new Error(`Failed to upload media ${index} to presigned URL`);
        }
      });

      const uploadedMediaMetadata = await Promise.all(uploadPromises);
      showToast("Media uploaded successfully", "success");
      setMediaUploaded(true);
    } catch (error) {
      console.error("Error uploading media:", error);
      showToast("Failed to upload media", "error");
    } finally {
      setLoading(false);
    }
  };

  const markAsPacked = async () => {
    try {
      setLoading(true);
      const requestBody = {
        order_id: currentOrder.id,
        products: selectedProducts,
      };
      if (tagId) {
        requestBody.tag_id = tagId;
      }
      const response = await UPDATE_INVENTORY(requestBody);
      if (response.status === 200) {
        setCanSearchNewOrder(true);
        setCapturedPhotos([]);
        setNewCapturedPhotos([]);
        setRecordedVideos([]);
        setCurrentOrder(null);
        setSearchInput("");
        setSelectedProducts([]);
        setScannedBarcode("");
        setActiveBarcode(null);

        Swal.fire({
          icon: "success",
          title: "Inventory Updated",
          text: "Inventory updated successfully.",
          confirmButtonColor: "#3085d6",
        });
      } else {
        throw new Error(response.data.message || "Error packing order");
      }
    } catch (error) {
      console.error("Error in markAsPacked:", error);
      if (error.response?.data?.err === "Missing inventory data at this location") {
        showToast("Order not found at this location. Please verify the location.", "error");
      } else {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "There was an error updating the inventory. Please try again.",
        confirmButtonColor: "#3085d6",
      });
    }} finally {
      setLoading(false);
    }
  };
 
  const handleRemoveAll = async () => {
    const confirmRemoveAll = await Swal.fire({
      icon: "warning",
      title: "Are you sure?",
      text: "This action will remove all media associated with this order. This cannot be undone.",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, remove all media!",
    });

    if (confirmRemoveAll.isConfirmed) {
      try {
        const response = await DELETE_ALL_ORDER_MEDIA(currentOrder.id);

        if (response.status === 200) {
          Swal.fire({
            icon: "success",
            text: "All media removed successfully.",
          });
          setCurrentOrder((prevData) => ({
            ...prevData,
            video_count: 0,
            image_count: 0,
            OrderMedia: [],
          }));
        } else {
          Swal.fire({
            icon: "error",
            text: response.data.message || "Error removing media",
          });
        }
      } catch (err) {
        console.log(err);
        Swal.fire({
          icon: "error",
          text: "An error occurred while removing media.",
        });
      }
    }
  };

  const handleDelete = async (mediaId) => {
    const confirmDelete = await Swal.fire({
      icon: "warning",
      title: "Are you sure?",
      text: "This action cannot be undone.",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    });

    if (confirmDelete.isConfirmed) {
      try {
        const response = await DELETE_SINGELORDER_MEDIA(mediaId);

        if (response.status === 200) {
          setCurrentOrder((prevOrder) => ({
            ...prevOrder,
            OrderMedia: prevOrder.OrderMedia.filter(
              (item) => item.id !== mediaId
            ),
          }));

          Swal.fire({
            icon: "success",
            text: "Media deleted successfully.",
          });

          const updatedOrderResponse = await FETCH_RTO_ORDER_DETAILS(
            currentOrder.order_numberF
          );
          if (updatedOrderResponse.status === 200) {
            setCurrentOrder(updatedOrderResponse.data.data);
          }
        } else {
          Swal.fire({
            icon: "error",
            text: response.data.message || "Error deleting media",
          });
        }
      } catch (err) {
        Swal.fire({
          icon: "error",
          text: "Network error deleting media",
        });
      }
    }
  };

  const handleManualCapture = (selectedCameras) => {
    capturePhoto(selectedCameras);
  };

  const handleManualRecording = (selectedCameras) => {
    if (activeRecordings.size > 0) {
      stopRecording(Array.from(activeRecordings));
    } else {
      startRecording(selectedCameras);
    }
  };
  useEffect(() => {
    if (loading) {
      message.warning("Loading...");
    } else {
      message.destroy();
    }
  }, [loading]);
  return (
    <>
      <div className={styles.section} style={{ marginBottom: "120px" }}>
        <div className={styles.row}>
          <div className={styles.col}>
            <>
              <OrderLineItems
                orderData={currentOrder}
                setCurrentOrder={setCurrentOrder}
                onSelectionChange={(selectedProducts) => {
                  setSelectedProducts(selectedProducts);
                }}
                scannedBarcode={scannedBarcode}
              />
            </>
          </div>
          <div className={styles.col}>
            <Card
              className={cn(styles.card)}
              title="Orders"
              classTitle={cn("title-purple", styles.title)}
              classCardHead={cn(styles.head)}
              head={
                <>
                  <Form
                    className={styles.form}
                    value={searchInput}
                    setValue={setSearchInput}
                    placeholder={
                      canSearchNewOrder
                        ? "Scan Order Number"
                        : " SKU ,Camera Mode"
                    }
                    type="text"
                    name="search"
                    icon="search"
                    autoFocus={true}
                    onSubmit={handleSearch}
                  />
                  {activeRecordings.size > 0 && (
                    <Image
                      className="h-[25px] w-[60px]"
                      srcDark={Record}
                      src={Record}
                      alt="Record"
                    />
                  )}
                  <Dropdown
                    className={styles.locationDropdown}
                    value={selectedLocation}
                    setValue={handleLocationChange}
                    options={[
                      "Select a location",
                      ...locations.map((location) => location.name),
                    ]}
                  />
                </>
              }
            >
              <div className="flex flex-wrap gap-[15px]">
                {cameras.map((camera, index) => (
                  <div key={camera.id}>
                    <p className="mb-[15px]">{camera.name}</p>
                    {camera.deviceId ? (
                      <>
                        <video
                          ref={(el) => (videoRefs.current[index] = el)}
                          width="275"
                          height="273"
                          autoPlay
                          muted
                          style={{ flex: "1 1 120px", borderRadius: "12px" }}
                        />
                        <div className="flex gap-2 justify-center mt-2">
                          {currentOrder && (
                            <>
                              <button
                                onClick={() => capturePhoto([camera.deviceId])}
                                className={cn("button-stroke ", styles.button)}
                              >
                                <Icon name="photo" size="24" fill="red" />
                                Photo
                              </button>
                              {activeRecordings.has(camera.deviceId) ? (
                                <button
                                  onClick={() =>
                                    stopRecording([camera.deviceId])
                                  }
                                  className={cn(
                                    "button-stroke-recording ",
                                    styles.button
                                  )}
                                >
                                  <Icon name="recording" size="24" fill="red" />{" "}
                                  Recording
                                </button>
                              ) : (
                                <button
                                  onClick={() =>
                                    startRecording([camera.deviceId])
                                  }
                                  className={cn(
                                    "button-stroke mr-[10px]",
                                    styles.button
                                  )}
                                >
                                  <Icon
                                    name="video_icon"
                                    size="24"
                                    fill="red"
                                  />
                                  Video
                                </button>
                              )}
                            </>
                          )}
                        </div>
                      </>
                    ) : (
                      <Image
                        className={styles.pic}
                        src={CameraImage}
                        srcDark={CameraImage}
                        alt="Core"
                      />
                    )}
                  </div>
                ))}
              </div>

              {currentOrder && (
                <div className="mt-[50px]">
                  <Product
                    initialOrderMedia={currentOrder.OrderMedia}
                    orderNumber={currentOrder.order_number}
                    handleRemoveAll={handleRemoveAll}
                    handleDelete={handleDelete}
                    mediaUploaded={mediaUploaded}
                    setMediaUploaded={setMediaUploaded}
                  />
                </div>
              )}
            </Card>
          </div>
        </div>
        {currentOrder && (
          <div className="fixed bottom-7 left-30 right-5 ">
            <Panel
              cameras={cameras}
              handleCapture={capturePhoto}
              handleRecording={handleManualRecording}
              activeRecordings={activeRecordings}
              markAsPacked={markAsPacked}
              currentOrder={currentOrder}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default RTOrderIndex;
